var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import VentanaSimple from '../../ventana-simple';
import Botonera from '../../ventana-simple/botonera';
import ContenidoVentana from '../../contenido-ventana';
import * as actions from '../../actions';
import { PANTALLA_VENTANA_ID } from '../../constantes';

var vinculoAZona = function vinculoAZona(zonaId) {
  return {
    vinculo: 'funcion,abrirZona:' + zonaId
  };
};

var SegundaVentana = (_temp = _class = function (_Component) {
  _inherits(SegundaVentana, _Component);

  function SegundaVentana(props) {
    _classCallCheck(this, SegundaVentana);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      width: null,
      height: null,
      anchoContenido: '100%',
      altoContenido: '100%',
      factor: 100
    };
    return _this;
  }

  SegundaVentana.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.boton.id !== this.props.boton.id) {
      this.setState({
        width: null,
        height: null,
        anchoContenido: '100%',
        altoContenido: '100%'
      });
    }

    var _props = this.props,
        libroId = _props.libroId,
        numPagina = _props.numPagina,
        numZona = _props.numZona,
        boton = _props.boton;
    var idBoton = boton.id.split(',')[0];
    var prevIdBoton = prevProps.boton.id.split(',')[0];

    if (prevProps.libroId !== libroId || prevProps.numPagina !== numPagina || prevProps.numZona !== numZona || idBoton !== prevIdBoton) {
      this.setState({
        factor: 100
      });
    }
  };

  SegundaVentana.prototype.renderBotonera = function renderBotonera(forzarLupaNO) {
    var _props2 = this.props,
        consolaAudio = _props2.consolaAudio,
        textoTrack = _props2.textoTrack,
        consolaLupa = _props2.consolaLupa,
        botones = _props2.botones,
        flotante = _props2.flotante,
        onBoton = _props2.onBoton,
        onCerrar = _props2.onCerrar; // const marcoAmpliacionId = this.getMarcoAmpliacionId();

    return React.createElement(Botonera // marcoAmpliacionId={ marcoAmpliacionId }
    , {
      flotante: flotante,
      consolaLupa: consolaLupa,
      consolaAudio: consolaAudio,
      textoTrack: textoTrack,
      botones: botones,
      onCerrar: onCerrar,
      onBoton: onBoton,
      onZoomMas: this.zoomMas,
      onZoomInicial: this.zoomInicial,
      onZoomMenos: this.zoomMenos,
      forzarLupaNO: forzarLupaNO,
      factorActual: this.state.factor,
      configVentana: this.props.configSegundaVentana
    });
  };

  SegundaVentana.prototype.render = function render() {
    var abierta = this.props.abierta;
    var _props3 = this.props,
        contenido = _props3.contenido,
        flotante = _props3.flotante,
        escalable = _props3.escalable,
        ajusteInicial = _props3.ajusteInicial,
        tieneAnimacion = _props3.tieneAnimacion,
        boton = _props3.boton;
    var tipo = contenido.tipo;
    var forzarLupaNO = tipo === 'zoom' || tipo === 'png' ? false : true; // const forzarLupaNO = (tipo === 'zoom') ? false : true

    var claseExtra = 'segundaVentanaID' + boton.id.split(',')[0];
    return React.createElement(VentanaSimple, {
      tieneAnimacion: tieneAnimacion,
      flotante: flotante,
      escalable: escalable,
      ajusteInicial: ajusteInicial,
      abierta: abierta,
      claseExtra: claseExtra,
      ancho: isNaN(this.state.anchoContenido) ? this.state.anchoContenido : this.state.anchoContenido + 100,
      alto: isNaN(this.state.altoContenido) ? this.state.altoContenido : this.state.altoContenido + 100,
      onResize: this.handleResize
    }, this.renderBotonera(forzarLupaNO), abierta && tipo === 'zoom' && this.renderContenidoTipoZoom(), abierta && tipo === 'video' && this.renderContenidoTipoVideo(), abierta && tipo === 'funcion,abrirIframe' && this.renderContenidoTipoIframe(), abierta && tipo === 'ejercicio' && this.renderContenidoTipoEjercicio(), abierta && tipo === 'historia' && this.renderContenidoTipoHistoria(), abierta && tipo === 'png' && this.renderContenidoTipoPng());
  };

  return SegundaVentana;
}(Component), _class.defaultProps = {
  abierta: false,
  tieneAnimacion: true,
  escalable: false
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.zoomMas = function () {
    var configZoom = _this2.props.configSegundaVentana;
    var factor = _this2.state.factor;
    var aumentoZoom = configZoom.aumento || 0;
    var multiplicadorZoom = configZoom.multiplicador || 1;
    var pasosZoom = configZoom.maxPasos || 0;
    var maxFactor = 100;

    for (var i = 0; i < pasosZoom; i++) {
      maxFactor = multiplicadorZoom * maxFactor + aumentoZoom;
    }

    var nextFactor = multiplicadorZoom * factor + aumentoZoom;

    if (nextFactor <= maxFactor) {
      _this2.setState({
        factor: nextFactor
      }, function () {
        return _this2.forceUpdate();
      });
    }
  };

  this.zoomMenos = function () {
    var configZoom = _this2.props.configSegundaVentana;
    var factor = _this2.state.factor;
    var aumentoZoom = configZoom.aumento || 0;
    var multiplicadorZoom = configZoom.multiplicador || 1;
    var pasosZoom = configZoom.minPasos || 0;
    var minFactor = 100;

    for (var i = 0; i < pasosZoom; i++) {
      minFactor = (minFactor - aumentoZoom) / multiplicadorZoom;
    }

    var nextFactor = (factor - aumentoZoom) / multiplicadorZoom;

    if (nextFactor >= minFactor) {
      _this2.setState({
        factor: nextFactor
      }, function () {
        return _this2.forceUpdate();
      });
    }
  };

  this.zoomInicial = function () {
    _this2.setState({
      factor: 100
    }, function () {
      return _this2.forceUpdate();
    });
  };

  this.renderContenidoTipoIframe = function () {
    var src = _this2.props.contenido.src; //        const marcoAmpliacionId = this.getMarcoAmpliacionId();
    // TODO: hay que definir un tam y resolucion para la pizarra, ya que el tamaño del contenido del iframe es desconocido
    // return <ContenidoTipoIframe marcoAmpliacionId={ marcoAmpliacionId } src={ src } libroId={libroId} numPagina={ numPagina} pizarra={this.props.pizarra} />

    return React.createElement(ContenidoVentana.ContenidoTipoIframe, {
      src: src,
      pizarra: _this2.props.pizarra
    });
  };

  this.renderContenidoTipoEjercicio = function () {
    var src = _this2.props.contenido.src; //        const marcoAmpliacionId = this.getMarcoAmpliacionId();
    // TODO: hay que definir un tam y resolucion para la pizarra, ya que el tamaño del contenido del ejercicio es desconocido
    // return <ContenidoTipoEjercicio marcoAmpliacionId={ marcoAmpliacionId } src={ src } libroId={libroId} numPagina={ numPagina} pizarra={this.props.pizarra} />

    return React.createElement(ContenidoVentana.ContenidoTipoEjercicio, {
      src: src,
      pizarra: _this2.props.pizarra
    }); // return <ReactJson src={ this.props } />
  };

  this.renderContenidoTipoPng = function () {
    var _props4 = _this2.props,
        ajuste = _props4.ajuste,
        escala = _props4.escala,
        consolaLupa = _props4.consolaLupa;
    var factor = _this2.state.factor;
    var lupa = consolaLupa.split(',')[0];
    return React.createElement(ContenidoVentana.ContenidoTipoPng, _extends({}, _this2.props.contenido, {
      factor: factor,
      lupa: lupa,
      ajuste: ajuste || "auto",
      escala: escala || 100
    }));
  };

  this.renderContenidoTipoZoom = function () {
    var _props5 = _this2.props,
        contenido = _props5.contenido,
        ajuste = _props5.ajuste,
        escala = _props5.escala,
        consolaLupa = _props5.consolaLupa;
    var imagen = contenido.imagen,
        coordenadas = contenido.coordenadas;
    var _state = _this2.state,
        width = _state.width,
        height = _state.height,
        factor = _state.factor;
    var lupa = consolaLupa.split(',')[0];
    return React.createElement(ContenidoVentana.ContenidoTipoZoom, {
      // marcoAmpliacionId={ this.getMarcoAmpliacionId() }
      //factor={ 100 }
      factor: factor,
      imagen: imagen,
      coordenadas: coordenadas,
      ajuste: ajuste || "auto",
      escala: escala || 100,
      lupa: lupa,
      contenido: contenido,
      configLibros: null,
      esPrimeraVentana: false,
      anchoDisponible: width,
      altoDisponible: height,
      onImagenFinalRect: function onImagenFinalRect(rect) {
        _this2.setState({
          anchoContenido: rect.width,
          altoContenido: rect.height
        });
      }
    });
  };

  this.renderContenidoTipoVideo = function () {
    var _props6 = _this2.props,
        id = _props6.id,
        contenido = _props6.contenido,
        onBoton = _props6.onBoton; // const marcoAmpliacionId = this.getMarcoAmpliacionId()

    var autoplay = contenido.autoplay,
        carpeta = contenido.carpeta,
        archivo = contenido.archivo,
        numVideosCarrusel = contenido.numVideosCarrusel,
        titulo = contenido.titulo,
        zonaAnterior = contenido.zonaAnterior,
        zonaSiguiente = contenido.zonaSiguiente;
    var onAnterior = zonaAnterior ? function () {
      return onBoton(vinculoAZona(contenido.zonaAnterior), id);
    } : false;
    var onSiguiente = zonaSiguiente ? function () {
      return onBoton(vinculoAZona(contenido.zonaSiguiente), id);
    } : false;
    return React.createElement(ContenidoVentana.ContenidoTipoVideo, _extends({
      // marcoAmpliacionId={ marcoAmpliacionId }
      autoPlay: autoplay,
      archivo: archivo,
      numVideosCarrusel: numVideosCarrusel,
      titulo: titulo,
      carpeta: carpeta
    }, contenido, {
      onSiguiente: onSiguiente,
      onAnterior: onAnterior
    }));
  };

  this.renderContenidoTipoHistoria = function () {
    var _props7 = _this2.props,
        libroId = _props7.libroId,
        numPagina = _props7.numPagina,
        contenido = _props7.contenido,
        pizarra = _props7.pizarra,
        onBoton = _props7.onBoton;

    if (contenido.numPaso === 'AUTO') {
      return React.createElement(ContenidoVentana.ContenidoTipoHistoriaAutoSegundaVentana, _extends({
        libroId: libroId,
        numPagina: numPagina
      }, contenido, {
        pizarra: pizarra,
        onBoton: onBoton
      }));
    }

    return React.createElement(ContenidoVentana.ContenidoTipoHistoriaManualSegundaVentana, _extends({
      libroId: libroId,
      numPagina: numPagina
    }, contenido, {
      pizarra: pizarra,
      onBoton: function onBoton(vinculo) {
        // onBoton
        var props = {
          boton: _extends({}, _this2.props.boton, {
            vinculo: vinculo
          })
        };

        _this2.props.dispatch(actions.pantalla(PANTALLA_VENTANA_ID, props));
      }
    }));
  };

  this.handleResize = function (w, h, anchoPorcentaje, altoPorcentaje) {
    _this2.setState({
      width: w,
      height: h
    });
  };
}, _temp);
SegundaVentana.propTypes = process.env.NODE_ENV !== "production" ? {
  abierta: t.bool.isRequired,
  tieneAnimacion: t.bool.isRequired,
  escalable: t.bool.isRequired,
  flotante: t.bool.isRequired,
  configSegundaVentana: t.object,
  // botonera
  botones: t.array.isRequired,
  onBoton: t.func,
  // comportamiento ventana respecto al contenido
  ajusteInicial: t.string,
  // lupa (se integra en la botonera)
  consolaLupa: t.string.isRequired,
  ajuste: t.string.isRequired,
  escala: t.number,
  onZoomMas: t.func,
  onZoomInicial: t.func,
  onZoomMenos: t.func,
  // consola de audio ( se integra en la botonera)
  consolaAudio: t.string.isRequired,
  textoTrack: t.string,
  // boton cerrar (se integra en la botonera)
  onCerrar: t.func.isRequired,
  // contenido
  contenido: t.shape({
    id: t.string,
    tipo: t.string,
    libroId: t.string,
    numPagina: t.number,
    numZona: t.number,
    imagen: t.string,
    coordenadas: t.array,
    src: t.string
  }).isRequired,
  pizarra: t.object,
  id: t.string,
  libroId: t.string,
  numPagina: t.number,
  numZona: t.number,
  boton: t.any,
  dispatch: t.func
} : {};
export default SegundaVentana;